import PropTypes from 'prop-types'

import Typography from '@mui/material/Typography'

NavBadge.propTypes = {
  /** How many things are waiting. Renders nothing at zero. */
  count: PropTypes.number,

  /** Palette colour the pill is filled with */
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error', 'info']),

  /** Placement, which differs between the two bars */
  sx: PropTypes.object,

  /** Test id for the badge */
  testId: PropTypes.string,
}

/**
 * The count on a navigation destination, worn by both the tab bar and the side panel.
 *
 * @param {object} props - The component props.
 * @returns {JSX.Element|null} The rendered badge.
 */
export default function NavBadge({ count = 0, color = 'error', sx, testId }) {
  if (count <= 0) return null

  return (
    <Typography component="span" variant="caption" sx={[styles.badge(color), sx]} data-testid={testId}>
      {count > 99 ? '99+' : count}
    </Typography>
  )
}

const styles = {
  badge: (color) => ({
    px: 0.5,
    borderRadius: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    lineHeight: 1,
    backgroundColor: `${color}.main`,
    // Warning is a yellow the app draws ink on, not white
    color: color === 'warning' ? 'text.primary' : 'common.white',
  }),
}
